import React from 'react';
import { FaPerson, FaRegFilePdf, FaWhatsapp } from 'react-icons/fa6';
import { IoPrintSharp } from 'react-icons/io5';
import { MdMarkEmailUnread } from 'react-icons/md';
import { RxCross2 } from 'react-icons/rx';
import { LiaSmsSolid } from "react-icons/lia";
import { BsCurrencyDollar } from "react-icons/bs";  
import './Ticket.css'

function TicketConfirmation() {
  return (
    <section className="container-fluid ">
    <div className="container">
    <div className="flightBookingHeaderDiv">
            <div
              className="flightBookingUpperIcon"
            //   onClick={() => setHidePerson(!hidePerson)}
            >
              <FaPerson />
              <span className="hotelBookingHideDetails hotelBookingBigTag">
                Hide person
              </span>
            </div>
            <div className="flightBookingUpperIcon" 
            // onClick={downloadPdf}
            >
              <IoPrintSharp />
              <span className="hotelBookingHideDetails"> Print</span>
            </div>
            <div className="flightBookingUpperIcon" 
            // onClick={downloadPdf}
            >
              <FaRegFilePdf />
              <span className="hotelBookingHideDetails hotelBookingBigTag">
                {" "}
                Save Pdf
              </span>
            </div>
            <div className="flightBookingUpperIcon">
              <MdMarkEmailUnread />
              <span className="hotelBookingHideDetails"> Email </span>
            </div>
            <div
              className="flightBookingUpperIcon"
            //   onClick={sendWhatsAppMessage}
            >
              <FaWhatsapp />
              <span className="hotelBookingHideDetails"> Whatsapp</span>
            </div>
            <div className="flightBookingUpperIcon">
              <LiaSmsSolid />
              <span className="hotelBookingHideDetails"> Sms</span>
            </div>
            <div
              className="flightBookingUpperIcon"
            //   onClick={() => setHidePrice(!hidePrice)}
            >
              <BsCurrencyDollar />
              <span className="hotelBookingHideDetails hotelBookingBigTag">
                {" "}
                Hide Price
              </span>
            </div>
            <div className="flightBookingUpperIcon">
              <BsCurrencyDollar />
              <span
                className="hotelBookingHideDetails"
                // onClick={() => setActive(!active)}
              >
                {" "}
                Markup
              </span>
            </div>
            <div
              style={{
                padding: "3px 6px",
                backgroundColor: "#db0e0edb",
                fontSize: "20px",
                color: "white",
              }}
            >
              <RxCross2 />
            </div>
          </div>
      <div className="maindiv" style={{width: "1024px", height: 'max-content', margin: '0 auto' }}>
        <div className="top-part" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '2px dashed #dedede', borderColor: 'transparent transparent #dedede transparent' ,padding: '0 4rem'}}>
          <div className="logo" style={{width: '200px',height: '70px'}}>
            <img
              src="data:image/png;base64,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"
              alt=""
              width="100%"
              height="100%"
            />
          </div>
          <div className="ticket-details" style={{display:'flex'}}>
            {/* <div className="details" style={{textAlign: 'right', marginLeft: '.8rem'}}>
              <h4 style={{color: '#2d3290' ,'fontWeight': 700, fontSize: '1.2rem'}}>
                Ticket-<span style={{ color: "#067e07" }}>Confirmed</span>
              </h4>
              <p style={{fontSize: '.9rem', marginBottom: '.5rem !important'}}>
                <span style={{fontWeight: '700'}}>HT Booking ID:</span> HT-435
              </p>
              <p style={{fontSize: '.9rem', marginBottom: '.5rem !important'}}>
                <span style={{fontWeight: '700'}}>Booking Date:</span> Sun 09/06/2024
              </p>
              <p style={{fontSize: '.9rem', marginBottom: '.5rem !important'}}> 
                <span style={{fontWeight: '700'}}>Airline Confirmation PNR:</span> KNQPKY{" "}
              </p>
            </div> */}
            <div className="details" style={{textAlign: 'right', marginLeft: '8rem'}}>
              <h4 style={{color: '#2d3290' ,'fontWeight': 700, fontSize: '1.2rem'}}>
                Ticket-<span style={{ color: "#067e07" }}>Confirmed</span>
              </h4>
              <p style={{fontSize: '.9rem', marginBottom: '.5rem !important'}}>
                <span style={{fontWeight: '700'}}>HT Booking ID:</span> HT-435
              </p>
              <p style={{fontSize: '.9rem', marginBottom: '.5rem !important'}}>
                <span style={{fontWeight: '700'}}>Booking Date:</span> Sun 09/06/2024
              </p>
              <p style={{fontSize: '.9rem', marginBottom: '.5rem !important'}}>
                <span style={{fontWeight: '700'}}>Airline Confirmation PNR:</span> KNQPKY{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="passenger-details" style={{padding: '1rem 0'}}>
          <h4 style={{fontSize: '1rem', padding: '0 3.4rem', color: '#2d3290', fontWeight: '700'}}> Passenger - 5 Adult 1 Child </h4>
          <table className="table table-bordered text-center" style={{fontSize: '.9rem', width: '90%', margin: '0 auto'}}>
            <thead>
              <tr>
                <th scope="col">Passenger</th>
                <th scope="col">Airline</th>
                <th scope="col">Status</th>
                <th scope="col">Sector</th>
                <th scope="col">Airline PNR</th>
                <th scope="col">Ticket Number</th>
                <th scope="col">Seat No.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mr. Keshav Jindal </td>
                <td>TK</td>
                <td>Confirm</td>
                <td>IST-BRU</td>
                <td>SNWTHY</td>
                <td>235114754789/1/1</td>
                <td>A-50</td>
              </tr>
              <tr>
                <td>Mr. Keshav Jindal </td>
                <td>TK</td>
                <td>Confirm</td>
                <td>IST-BRU</td>
                <td>SNWTHY</td>
                <td>235114754789/1/1</td>
                <td>A-50</td>
              </tr>
              <tr>
                <td>Mr. Keshav Jindal </td>
                <td>TK</td>
                <td>Confirm</td>
                <td>IST-BRU</td>
                <td>SNWTHY</td>
                <td>235114754789/1/1</td>
                <td>A-50</td>
              </tr>
              <tr>
                <td>Mr. Keshav Jindal </td>
                <td>TK</td>
                <td>Confirm</td>
                <td>IST-BRU</td>
                <td>SNWTHY</td>
                <td>235114754789/1/1</td>
                <td>A-50</td>
              </tr>
              <tr>
                <td>Mr. Keshav Jindal </td>
                <td>TK</td>
                <td>Confirm</td>
                <td>IST-BRU</td>
                <td>SNWTHY</td>
                <td>235114754789/1/1</td>
                <td>A-50</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="flight-details" style={{padding: '1rem 0'}}>
          <h4 style={{fontSize: '1rem', padding: '0 3.4rem', color: '#2d3290', fontWeight: 700}}> Flight Details </h4>
          <table className="table text-center table-bordered" style={{fontSize: '.9rem' ,width: '90%', margin: '0 auto'}}>
            <thead className=" table-primary">
              <tr>
                <th scope="col" colSpan={2}>
                  Airline Details
                </th>
                <th scope="col">Departure</th>
                <th scope="col">Arrival</th>
                <th scope="col">Duration</th>
                <th scope="col">Terminal</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <i className="fa-solid fa-plane-circle-check fa-fw" />{" "}
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>Qatar Airways</span>
                    <br />
                    QR1019 Cabin Class:
                    <br />
                    (Economy)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 12:30 AM
                    </span>
                    <br />
                    Dubai Intl
                    <br />
                    (DXB)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 02:15 AM
                    </span>
                    <br />
                    Doha
                    <br />
                    (DOH)
                  </p>
                </td>
                <td>01h:45m</td>
                <td>Terminal 1</td>
              </tr>
              <tr>
                <td>
                  <i className="fa-solid fa-plane-circle-check fa-fw" />{" "}
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>Qatar Airways</span>
                    <br />
                    QR1019 Cabin Class:
                    <br />
                    (Economy)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 12:30 AM
                    </span>
                    <br />
                    Dubai Intl
                    <br />
                    (DXB)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 02:15 AM
                    </span>
                    <br />
                    Doha
                    <br />
                    (DOH)
                  </p>
                </td>
                <td>01h:45m</td>
                <td>Terminal 1</td>
              </tr>
              <tr>
                <td>
                  <i className="fa-solid fa-plane-circle-check fa-fw" />{" "}
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>Qatar Airways</span>
                    <br />
                    QR1019 Cabin Class:
                    <br />
                    (Economy)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 12:30 AM
                    </span>
                    <br />
                    Dubai Intl
                    <br />
                    (DXB)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 02:15 AM
                    </span>
                    <br />
                    Doha
                    <br />
                    (DOH)
                  </p>
                </td>
                <td>01h:45m</td>
                <td>Terminal 1</td>
              </tr>
              <tr>
                <td>
                  <i className="fa-solid fa-plane-circle-check fa-fw" />{" "}
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>Qatar Airways</span>
                    <br />
                    QR1019 Cabin Class:
                    <br />
                    (Economy)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 12:30 AM
                    </span>
                    <br />
                    Dubai Intl
                    <br />
                    (DXB)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 02:15 AM
                    </span>
                    <br />
                    Doha
                    <br />
                    (DOH)
                  </p>
                </td>
                <td>01h:45m</td>
                <td>Terminal 1</td>
              </tr>
              <tr>
                <td>
                  <i className="fa-solid fa-plane-circle-check fa-fw" />{" "}
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>Qatar Airways</span>
                    <br />
                    QR1019 Cabin Class:
                    <br />
                    (Economy)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 12:30 AM
                    </span>
                    <br />
                    Dubai Intl
                    <br />
                    (DXB)
                  </p>
                </td>
                <td>
                  <p>
                    <span style={{ fontWeight: 600 }}>
                      17 July 2024 02:15 AM
                    </span>
                    <br />
                    Doha
                    <br />
                    (DOH)
                  </p>
                </td>
                <td>01h:45m</td>
                <td>Terminal 1</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="baggage-flight" style={{padding: '1rem 0'}}>
          <h4 style={{fontSize: '1rem', padding: '0 3.4rem', color: '#2d3290', fontWeight: '700'}}> Baggage Info </h4>
          <table className="table text-center table-bordered" style={{fontSize: '.9rem', width: '90%', margin: '0 auto'}}>
            <thead>
              <tr>
                <th scope="col" rowSpan={2}>
                  Airline
                </th>
                <th scope="col" rowSpan={2}>
                  Sector
                </th>
                <th scope="col" colSpan={2}>
                  Baggage
                </th>
              </tr>
              <tr>
                <th scope="col">Check-In</th>
                <th scope="col">Cabin</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>TK</td>
                <td>IST-BRU</td>
                <td>23kg</td>
                <td>7kg</td>
              </tr>
              <tr>
                <td>TK</td>
                <td>IST-BRU</td>
                <td>23kg</td>
                <td>7kg</td>
              </tr>
              <tr>
                <td>TK</td>
                <td>IST-BRU</td>
                <td>23kg</td>
                <td>7kg</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="flight-details"style={{padding: '1rem 0'}}>
          <h4 style={{fontSize: '1rem', padding: '0 3.4rem', color: '#2d3290', fontWeight: 700}}> Fare Info </h4>
          <table className="table text-center table-bordered" style={{fontSize: '.9rem' ,width: '90%', margin: '0 auto'}}>
            <thead className=" table-primary">
              <tr>
                <th scope="col"> Base Fare</th>
                <th scope="col">Taxes &amp; Surcharges</th>
                <th scope="col">Discount</th>
                <th scope="col">Service Fee</th>
                <th scope="col">Excess Baggage</th>
                <th scope="col">Meal</th>
                <th scope="col">Seat Charges</th>
                <th scope="col">Other Charges</th>
                <th scope="col">Total Fare</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>$ 115.18</td>
                <td> $ 18.68 </td>
                <td>$ 0</td>
                <td>$ 0</td>
                <td>$ 0</td>
                <td>$ 0</td>
                <td>$ 0</td>
                <td>$ 0</td>
                <td>$ 129.52</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="personal-details" style={{padding: '1rem 0'}}>
          <h4 style={{fontSize: '1rem', padding: '0 3.4rem', color: '#2d3290', fontWeight: 700}}> Company Contact Details </h4>
          <table className="table table-bordered" style={{fontSize: '.9rem' ,width: '90%', margin: '0 auto'}}>
            <tbody>
              <tr>
                <td style={{ fontWeight: 700 }}>Name</td>
                <td>Abasin Tourist &amp; Travel Agency</td>
              </tr>
              <tr>
                <td style={{ fontWeight: 700 }}>Address</td>
                <td>
                  Shah-re-naw Ansari square, kolola pushta road , Kabul,
                  Afghanistan, AF-
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: 700 }}>Contact</td>
                <td>93779897682 | 0093785336735 </td>
              </tr>
              <tr>
                <td style={{ fontWeight: 700 }}>Email</td>
                <td>support@abasinexpress.com</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="information-details" style={{padding: '1rem 0'}}>
          <h5 style={{fontSize: '1rem', padding: '0 3.4rem', color: '#2d3290', fontWeight: 700}}>Passport/Visa/Health</h5>
          <ul style={{fontSize: '.9rem' ,width: '90%', margin: '0 auto'}}>
            <li>
              {" "}
              Please ensure that you have all the required travel documents for
              your entire journey i.e., valid passport &amp; necessary visas,
              and that you have had the recommended inoculations for your
              destination(s).
            </li>
            <li>
              {" "}
              All passengers, including children and infants, have to present
              their valid ID proof at the time of check-in.
            </li>
            <li>
              {" "}
              We recommend you checkin at least 3 hours prior to departure of
              your domestic flight and 4 hours prior to your international
              flight
            </li>
            <li>
              Carriage and other facilities provided by the carrier are subject
              to their Terms and Condition. We are not liable for missing any
              facility of the carrier.
            </li>
            <li>
              Recheck your baggage with your respective airline before traveling
              for hassle-free travel experience.
            </li>
            <li>
              Group Booking Rules will be applicable if passengers are 9 or more
              in numbers.
            </li>
            <li>
              Company is not responsible for any delay or cancellation of
              flights from airline's end.
            </li>
            <li>
              Unaccompanied Child: Children below the age of 12 will not be
              accepted for carriage unless they are accompanied by a person of
              at least 18 years of age. Such child/children must be seated next
              to the accompanying adult. The accompanying adult is solely
              responsible for the well-being of the child/children traveling
              together with him/her. This also includes ensuring that seats are
              booked to ensure child/children and an accompanying adult are
              seated together.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  );
}

export default TicketConfirmation;
